import {Config, Environment} from "./config";

export const dev: Config = {
    environment: Environment.DEV,
    showEnvLabel: true,
    server: "https://tui-backend.eevie.pet.cloud.audi",
}